import {BaseApi, HttpMethodEnum} from '../BaseApi/BaseApi';
import {
    IQuestionnaireAnswer,
    IQuestionnaireAnswerPayload,
    IQuestionnaireScore
} from '../../entities/QuestionnaireAnswer/QuestionnaireAnswer.ts';

export class QuestionnaireAnswerApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/QuestionnaireAnswers`;

    public static apiUrls = {
        getQuestionnaireAnswerByTaskId: `${QuestionnaireAnswerApi.baseApiUrl}/:id`,
        getQuestionnaireAnswerByTaskIdAndToken: `${BaseApi.apiUrl}/Collaborators`,
        postQuestionnaireAnswer: `${QuestionnaireAnswerApi.baseApiUrl}`,
        getQuestionnaireScoresByQuestionnaireId: `${QuestionnaireAnswerApi.baseApiUrl}/:patientId/:questionnaireId/scores`,
    };

    public static async getQuestionnaireAnswerByTaskId(id: string): Promise<IQuestionnaireAnswer> {
        return this.sendApiRequest<IQuestionnaireAnswer>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getQuestionnaireAnswerByTaskId,
            data: undefined,
            id: id
        });
    }

    public static async getQuestionnaireAnswerByTaskIdAndToken(taskId: string, token: string): Promise<IQuestionnaireAnswer> {
        return this.sendApiRequest<IQuestionnaireAnswer>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.getQuestionnaireAnswerByTaskIdAndToken}/${token}/Tasks/${taskId}`,
        });
    }

    public static async postQuestionnaireAnswer(data: IQuestionnaireAnswerPayload): Promise<IQuestionnaireAnswer> {
        return this.sendApiRequest<IQuestionnaireAnswer>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postQuestionnaireAnswer,
            data: data
        });
    }

    public static async getQuestionnaireScoresByQuestionnaireId(patientId: string, questionnaireId: string): Promise<IQuestionnaireScore[]> {
        return this.sendApiRequest<IQuestionnaireScore[]>({
            method: HttpMethodEnum.GET,
            path:  this.apiUrls.getQuestionnaireScoresByQuestionnaireId.replace(':patientId', patientId).replace(':questionnaireId', questionnaireId),
            data: undefined
        });
    }
}
